let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("igji4")).then(() => parcelRequire('8Giki'));